import type { AxiosRequestConfig, AxiosRequestHeaders } from 'axios'

import { isEmpty } from 'lodash'

import { authService } from 'auth'

const timestampConfig = () => ({ params: { t: new Date().getTime() } })

export const request = async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  const headers: AxiosRequestHeaders = {
    ...(config.headers as AxiosRequestHeaders),
  }

  if (config.method?.toUpperCase() === 'POST' && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json'
  }

  const accessToken = await authService.getAccessToken()

  if (!isEmpty(accessToken) && typeof accessToken === 'string') {
    headers.Authorization = `Bearer ${accessToken}`
  }

  return { ...config, headers, ...timestampConfig() }
}

export default request
